module.exports = __webpack_public_path__ + "img/swiper1.63bb3d7d.png";